import { type QueryClient } from "@tanstack/react-query";

import { getClipboardScoreProfileUrl } from "./useGetClipboardScoreProfile";

/**
 * Invalidates all cached Clipboard Score profile queries for a given user.
 * Uses URL-only prefix matching to invalidate regardless of query param variants
 * (qualification, workplaceId).
 */
export function invalidateClipboardScoreProfile(queryClient: QueryClient, userId: string): void {
  void queryClient.invalidateQueries({
    queryKey: [getClipboardScoreProfileUrl(userId)],
  });
}
